module.exports = __webpack_public_path__ + "images/shopping-cart-787576f21eec8cb4b518e323b424d2f8.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/shopping-cart.svg
// module id = ./client/assets/images/shopping-cart.svg
// module chunks = 1 6 7 8 9